import { useNavigate } from "react-router-dom";
import SUCCESSIMAGE from "../assets/img/success.png";
import styled from "styled-components";

const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: center;
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  width: 60%;

  img {
    width: 100px;
    align-self: center;
  }
`;

const Title = styled.h5`
  color: #005ca9;
  font-weight: 700;
  font-size: 20px;
`;

const Message = styled.p`
  margin-bottom: 20px;
  width: 70%;
`;

const BackButton = styled.button`
  background-color: #ff5641;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  padding: 10px;
  border: none;
  border-radius: 50px / 40px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
`;

interface SuccessDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SuccessDialog({ isOpen, onClose }: SuccessDialogProps) {
  const navigate = useNavigate();
  if (!isOpen) return null;
  

  const handleRedirect = () => {
    onClose(); 
    navigate("/"); 
  };

  return (
    <DialogOverlay>
      <DialogContainer>
        <img src={SUCCESSIMAGE} />
        <Title>Cadastro salvo com sucesso!</Title>
        <Message>
          Seu cadastro foi efetuado com sucesso. Faça o login com seu CPF e use
          os 5 primeiros dÍgitos do seu cpf como senha.{" "}
        </Message>
        <BackButton onClick={handleRedirect}>OK</BackButton>
      </DialogContainer>
    </DialogOverlay>
  );
}
